/*
 * @Author: yzr
 * @Date: 2020-12-08 10:51:48
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-08 10:54:25
 */
import uploadMsg from './upload_msg.vue';

export default uploadMsg;
